import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { useGetVoiceEngines } from '@/apis/agency/voiceEngines/hook';
import VoiceEngineCard from './components/VoiceEngineCard';
import VoiceEngineSkeleton from './components/VoiceEngineSkeleton';

const VoiceEngines = () => {
  const { data: voiceEngines, isLoading } = useGetVoiceEngines({ per_page: 999 });

  return (
    <Box>
      <Typography fontSize={20} fontWeight={500}>
        Voice Engines
      </Typography>
      <Typography variant='body2' color='text.secondary' fontSize={14} fontWeight={400} mb={3}>
        Manage and configure voice engines for your business.
      </Typography>

      <Grid container spacing={2}>
        {isLoading ? (
          <VoiceEngineSkeleton />
        ) : (
          voiceEngines?.data?.map((engine) => (
            <Grid key={engine.id} size={{ xs: 12, sm: 6, md: 4 }}>
              <VoiceEngineCard engine={engine} allEngines={voiceEngines?.data} />
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
};

export default VoiceEngines;
